import { UserManager, WebStorageStateStore, User } from 'oidc-client-ts'

import { tokenService } from './tokenService'

const setting = {
  authority: import.meta.env.VITE_OIDC_BASE_URL,
  client_id: import.meta.env.VITE_CLIENT_ID,
  client_secret: import.meta.env.VITE_CLIENT_SECRET,
  redirect_uri: import.meta.env.VITE_OAUTH_RETURN_URI,
  response_type: 'code',
  scope: import.meta.env.VITE_SCOPE,
  post_logout_redirect_uri: `${import.meta.env.VITE_BASE_URL}/login`,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: false
}

const userManager = new UserManager(setting)

const createAndStoreUser = async (
  access_token: string,
  refresh_token: string,
  token_type: string,
  expires_in: number
) => {
  const user = new User({
    access_token,
    refresh_token,
    token_type,
    expires_at: Math.floor(Date.now() / 1000) + expires_in,
    session_state: null,
    scope: import.meta.env.VITE_SCOPE,
    profile: {
      sub: '',
      iss: '',
      aud: '',
      exp: 0,
      iat: 0
    }
  })

  await userManager.storeUser(user)
}

const tokenUpdateHandler = (user: User) => {
  if (user?.access_token) {
    tokenService.setAccessToken(user.access_token)
  }
}

userManager.events.addUserLoaded(tokenUpdateHandler)

const initializeUserManager = async () => {
  try {
    await userManager.clearStaleState()
    const user = await userManager.getUser()
    if (user?.expired) {
      const newUser = await userManager.signinSilent()
      if (newUser) {
        tokenUpdateHandler(newUser)
      }
    } else if (user) {
      tokenUpdateHandler(user)
    }
  } catch (error) {
    console.error('Error loading user from storage:', error)
  }
}

export { userManager, initializeUserManager, createAndStoreUser }
